import React from 'react';
import PropTypes from "prop-types";

function QuickSearchBar({query, placeholder = 'Type a name', callback, queryChange}) {
    function handleSearchFormSubmit(event) {
        event.preventDefault();
        callback();
    }

    function onQueryChange(event) {
        event.preventDefault();
        queryChange(event.target.value);
    }

    return (
        <form onSubmit={handleSearchFormSubmit} className="form-inline">
            <label className="sr-only" htmlFor="query">Search</label>
            <input
                placeholder={placeholder}
                value={query}
                onChange={onQueryChange}
                type="text"
                className="form-control quick-search little"
                id="query"/>
            <button type="submit" className="button">
                <i className='fas fa-search'/>
                <span>Search</span>
            </button>
        </form>
    );
}

QuickSearchBar.propTypes = {
    query: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    callback: PropTypes.func.isRequired,
    queryChange: PropTypes.func.isRequired,
};

export default QuickSearchBar;
